import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Pressable,
} from 'react-native';
import Colors from '../constants/Colors';

interface TabSelectionMobileProps {
  options: any[],
  selectOption: Dispatch<SetStateAction<any>>,
  selectedOption: any,
  titles?: string[]
}

const TabSelectionMobile = ({
  options, selectOption, selectedOption, titles = [],
}: TabSelectionMobileProps) => <View style={styles.container}>
    {options.map((option: any, index: number) => {
      const selected: boolean = option === selectedOption;
      return <Pressable
        onPress={() => selectOption(option)}
        style={[styles.button, selected && { borderBottomColor: styles.selected.color }]}
        key={`tab_option_${option}`}
      >
        <Text style={[styles.title, selected && styles.selected]}>{titles[index] ?? option}</Text>
      </Pressable>;
    })}
  </View>;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: Colors.light.hereworksBlue100,
  },
  button: {
    borderBottomWidth: 4,
    borderBottomColor: 'transparent',
    paddingHorizontal: 12,
    paddingTop: 4,
    paddingBottom: 8,
    marginEnd: 8,
  },
  title: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack500,
  },
  selected: {
    color: Colors.light.hereworksBlue500,
  },
});

export default TabSelectionMobile;
